export find_parent_element = (element, nodeName = 'TR') ->
  parent = element
  parent = parent.parentElement while parent.nodeName != nodeName
  parent